<template>
    <div class="yq-view-style-select">
        <el-tag v-if="value" closable @close="$emit('input', null)" effect="plain">
            {{value.name}}
        </el-tag>
        <el-button @click="showDialog" size="mini">选择</el-button>
        <el-dialog
                title="选择样式"
                :visible.sync="dialogVisible"
                width="720px" append-to-body>
            <div class="yq-view-style-select-items-container">
                <div class="yq-view-style-select-items">
                    <div class="yq-view-style-select-item" v-for="item in items" :key="item.id" @click="toggleSelect(item)"
                         :class="{'yq-view-style-select-item-selected':value&&value.id===item.id}">
                        <div class="yq-view-style-select-item-thumbnail">
                            <img :src="item.thumbnail">
                        </div>
                        <div class="yq-view-style-select-item-name">{{item.name}}</div>
                    </div>
                </div>
                <infinite-loading :distance="50" spinner="waveDots" :identifier="infiniteId" @infinite="infiniteHandler">
                    <div slot="no-more"></div>
                    <div slot="no-results"></div>
                    <div slot="error">加载出错</div>
                </infinite-loading>
            </div>

            <div slot="footer" style="text-align: center;">
                <el-button type="primary" @click="dialogVisible = false">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import viewStyleService from '../../service/view-style'
    import InfiniteLoading from 'vue-infinite-loading'
    import templates from '../templates'

    export default {
        name: "ViewStyleSelect",
        components: {InfiniteLoading},
        props: {
            value: Object,
            datasourceId: Number
        },
        data() {
            return {
                dialogVisible: false,
                items: [],
                nextPage: 0,
                hasMore: true,
                infiniteId: 0
            }
        },
        watch:{
            datasourceId(){
                this.infiniteId++
            }
        },
        methods: {
            showDialog(){
                this.dialogVisible = true
            },
            infiniteHandler($state){
                if(!this.hasMore){
                    $state.complete()
                    return
                }
                if(!this.datasourceId){
                    this.hasMore = false
                    $state.complete()
                    return
                }
                viewStyleService.listViewStyles({
                    datasourceId: this.datasourceId,
                    page: this.nextPage,
                    size: 10
                }).then(response=>{
                    response.data.content.forEach(item=>{
                        item.thumbnail = templates.find(template=>template.id===item.componentId).thumbnail
                    })
                    this.items.push(...response.data.content)
                    this.nextPage++
                    this.hasMore = this.nextPage < response.data.totalPages
                    $state.loaded()
                }).catch(error=>{
                    $state.error()
                    throw error
                })
            },
            toggleSelect(item){
                if(this.value&&this.value.id===item.id){
                    this.$emit('input', null)
                }else{
                    this.$emit('input',{
                        id: item.id,
                        name: item.name
                    })
                }
            },
        }
    }
</script>
<style scoped>

</style>
